import { instanceWithAuth } from '.'

const w_l_lotto_user_num = () =>
  instanceWithAuth.post('/lotto/w_l_lotto_user_num')
const w_cu_lotto_user_num = (params) =>
  instanceWithAuth.post('/lotto/w_cu_lotto_user_num', params)
const w_d_lotto_user_num = (params) =>
  instanceWithAuth.post('/lotto/w_d_lotto_user_num', params)
const w_l_lotto_num = () => instanceWithAuth.post('/lotto/w_l_lotto_num')
const w_lotto_home = () => instanceWithAuth.post('/lotto/w_lotto_home')
const w_l_lotto_no = () => instanceWithAuth.post('/lotto/w_l_lotto_no')
const w_lotto_order_result = (params) =>
  instanceWithAuth.post('/lotto/w_lotto_order_result_page', params)
const w_c_lotto_order2 = (params) =>
  instanceWithAuth.post('/lotto/w_c_lotto_order2', params)
const w_l_lotto_amt = () => instanceWithAuth.post('/lotto/w_l_lotto_amt')
const lotto_order = (params) =>
  instanceWithAuth.post('/lotto/lotto_order', params)

export {
  w_l_lotto_user_num,
  w_cu_lotto_user_num,
  w_d_lotto_user_num,
  w_l_lotto_num,
  w_lotto_home,
  w_l_lotto_no,
  w_lotto_order_result,
  w_c_lotto_order2,
  w_l_lotto_amt,
  lotto_order
}
